'use strict';

var React = require('react');

/*
 @Author : mengxiaojiang
 @CreateDate : 2016-4-1
 @Descript : 弹出面板容器层
 */
var PopupPanelContent = React.createClass({

  render: function () {
    var dom = <div
      style={{
                left : this.props.x,
                    top : this.props.y,
                    width : this.props.w,
                    height : this.props.h,
                    backgroundColor : '#f00'
            }}
    >
      {this.props.children}
    </div>;
    return dom;
  }


});

module.exports = PopupPanelContent;



/** WEBPACK FOOTER **
 ** ./src/views/Components/PopupPanelContent.jsx
 **/